"use client";

import React from "react";
import { ShieldCheck, Zap, Clock, Headphones, ArrowRight } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const benefitsData = [{
  title: "Precision Engineering",
  description: "Strict adherence to structural integrity protocols and multi-phase stress testing for maximum durability.",
  icon: ShieldCheck
}, {
  title: "High-Efficiency Output",
  description: "Optimized deployment cycles and streamlined technical workflows to accelerate project completion timelines.",
  icon: Zap
}, {
  title: "Certified Technical Support",
  description: "Direct access to senior engineering specialists for real-time troubleshooting and operational guidance.",
  icon: Headphones
}, {
  title: "Lifecycle Management",
  description: "Comprehensive maintenance scheduling and asset tracking to ensure long-term performance stability.",
  icon: Clock
}];
export default function ServiceExplanationBenefits() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="79991" id="what-the-service-includes" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={leftRef} className={`flex flex-col items-start transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-sm font-medium text-primary mb-6 font-mono">
              ASTM STANDARDS
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 text-foreground font-sans">
              Technical Excellence in Every Component
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Our service framework is built on a foundation of rigorous technical specifications and industry-leading benchmarks. We transform complex operational requirements into streamlined, high-performance solutions that scale with your ambitions.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              By integrating advanced material science with precision logistics, we provide a comprehensive suite of deliverables designed for mission-critical environments. Every phase of our process is documented, verified, and optimized for total reliability.
            </p>
            
            <Button asChild size="lg" className="group bg-primary text-primary-foreground hover:bg-primary/90 rounded-md">
              <Link to="/HomeInspectionServicePage">
                View Technical Specs
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out delay-200 border border-border rounded-lg p-8 bg-card shadow-sm ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {benefitsData.map((benefit, index) => {
            const Icon = benefit.icon;
            return <div key={index} data-index={index} className="flex items-start gap-5 group">
                  <div className="shrink-0 flex items-center justify-center size-12 rounded-xl bg-primary/10 text-secondary transition-colors duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                    <Icon className="size-6 stroke-[1.5px]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2 text-foreground font-sans">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>

        </div>
      </div>
    </section>;
}